import React from "react";
import { Card } from "antd";
import { PhotoIcon } from "@heroicons/react/24/outline";
import { ViewfinderCircleIcon } from "@heroicons/react/24/outline";
import { ReactComponent as MosquitoIcon } from "../../../assets/icons/MosquitoVector.svg";
import { Catalog } from "../../../types";
import { formatDate } from "../../../utils/helpers";
import "./index.css";

export interface ImageCardProps extends Catalog {
  deviceName?: string;
  trapSiteName?: string;
  onClick?: () => void;
}

const ImageCard: React.FC<ImageCardProps> = ({
  capture,
  imageType,
  img,
  specimen_uuid,
  algorithmId,
  humanId,
  deviceName,
  trapSiteName,
  onClick,
}) => {
  const { created_at, uuid: capture_uuid } = capture;
  const algorithmSpeciesName = algorithmId?.algorithmSpecies;
  const contributedSpeciesName = humanId?.contributed_species;
  const imageTitle = specimen_uuid
    ? `${capture_uuid}-${specimen_uuid}`
    : capture_uuid;
  const isContributed = contributedSpeciesName?.length > 0;
  const algorithmDetectionType = algorithmId?.detectionType || "";

  return (
    <Card
      hoverable
      className="card-image"
      onClick={onClick}
      styles={{ body: { padding: "12px" } }}
    >
      {/* Header: Icon + Title */}
      <div className="flex items-center gap-2 mb-1">
        {imageType === "Mesh" ? (
          <ViewfinderCircleIcon className="w-5 h-5 text-[#005F8F]" />
        ) : (
          <PhotoIcon className="w-5 h-5 text-[#005F8F]" />
        )}
        <h3 className="text-[#005F8F] font-bold text-base m-0 leading-tight">
          {imageTitle}
        </h3>
      </div>
      {/* Subtitle + Date */}
      <div className="flex justify-between items-center text-[#003952] text-xs mb-2">
        <span>
          {trapSiteName}-{deviceName}
        </span>
        <span>{formatDate(created_at)}</span>
      </div>
      {/* Status */}
      {imageType !== "Mesh" ? (
        isContributed ? (
          <div className="flex items-center gap-2 mb-1">
            <MosquitoIcon className="w-5 h-5 fill-current" />
            <span className="font-medium text-sm">
              {contributedSpeciesName}
            </span>
          </div>
        ) : (
          <div className="flex items-center gap-2 mb-1 text-[#FF6B6B]">
            <MosquitoIcon className="w-5 h-5 fill-current" />
            <span className="font-medium text-sm">
              {algorithmDetectionType === "Mosquito"
                ? algorithmSpeciesName || "Undefined"
                : algorithmDetectionType || "Unknown"}
            </span>
          </div>
        )
      ) : (
        <div className="h-5 mb-1" />
      )}
      {/* Image */}
      <div className="flex justify-center rounded-sm overflow-hidden aspect-15/13">
        <img
          src={img}
          alt={`${imageType}-${specimen_uuid || capture_uuid}-${created_at}`}
          className="w-full h-full object-cover"
        />
      </div>
    </Card>
  );
};

export default ImageCard;
